<template lang="pug">
h2
    | {{title}}
    span(v-if="description")
        v-tooltip(:tip="description", :pos="pos")
            i.fa.fa.fa-question-circle
    small {{dateStr}}
    slot
</template>

<script>
    import { getDateString } from '../../../script/util';

    export default {
        name: 'setting-title',
        props: {
            title: {
                required: true,
                default: '请输入页面Title'
            },
            description: {},
            pos: {
                default: 'right'
            },
            date: {
                type: Object
            }
        },
        computed: {
            dateStr() {
                if (!this.date) {
                    return getDateString(new Date(), '/');
                }

                let { start, end } = this.date;
                if (!start || !end) {
                    return getDateString(new Date(), '/');
                }

                start = start.replace(/-/g, '/');
                end = end.replace(/-/g, '/');
                return start === end ? start : `${start} - ${end}`;
            }
        }
    }
</script>

<style scoped>
h2 {
    position: relative;
}
small {
    font-family: Microsoft Yahei,sans-serif;
}
</style>



// WEBPACK FOOTER //
// general-title.vue?046a2f8e